import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 10a7 7 0 0 1 6.12-6.945 2 2 0 0 1 2.078 1.202l2.51 5.856a2 2 0 0 1-.165 1.883l-2.08 3.177.157.306a9.54 9.54 0 0 0 3.933 3.919l.312.157 3.13-2.086a2 2 0 0 1 1.74-.234l.157.06 5.852 2.507a2 2 0 0 1 1.2 2.085A7 7 0 0 1 22 28c-9.941 0-18-8.059-18-18m6.358-4.96-.216.034A5 5 0 0 0 6 10c0 8.837 7.163 16 16 16a5 5 0 0 0 4.96-4.358l-5.856-2.51-3.125 2.084c-.583.394-1.33.45-1.973.146a11.55 11.55 0 0 1-5.348-5.327 1.99 1.99 0 0 1 .132-1.956l2.08-3.178z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconLeadActivities = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLeadActivities);
export default Memo;
